import React from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ChatIcon from '@mui/icons-material/Chat';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 8, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Page Not Found
        </Typography>
        
        <Typography variant="subtitle1" paragraph>
          The page you're looking for doesn't exist or you don't have permission to access it.
        </Typography>
        
        <Box sx={{ mt: 4, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            You might be looking for one of these pages:
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 300, mx: 'auto', mt: 3 }}>
            <Button 
              variant="contained" 
              color="primary" 
              fullWidth
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
            >
              Go to Home
            </Button>
            
            <Button 
              variant="outlined" 
              color="primary" 
              fullWidth
              startIcon={<QuestionAnswerIcon />}
              onClick={() => navigate('/manage-qa')}
            >
              Manage Q&A
            </Button>
            
            <Button 
              variant="outlined" 
              color="secondary" 
              fullWidth
              startIcon={<ChatIcon />}
              onClick={() => navigate('/test-interface')}
            >
              Test AI Chat
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFound; 